/* eslint-disable consistent-return */
import axios from "axios";
export const spellcheckStarted = (assignmentId, assetId, request) => {
    postMetric({
        assignmentId,
        assetId,
        requestId: request.requestId,
        sourceText: request.source_text,
        targetText: request.target_text,
        sourceLang: request.source_lang,
        targetLang: request.target_lang,
    });
};
export const spellchecked = (requestId, result, noChanges) => {
    patchMetric(requestId, {
        spellcheckedText: result.spellchecked_text,
        changes: result.changes.sort((a, b) => a.start_pos - b.start_pos).map(mapSpellcheckChange),
        model: result.model || "gpt",
        noChanges,
        promptVersion: result.prompt_version || 1,
    });
};
export const spellcheckError = (requestId, error) => {
    patchMetric(requestId, {
        error,
    });
};
export const spellcheckFinished = (requestId, changes, finalText) => {
    patchMetric(requestId, {
        changes: changes.sort((a, b) => a.start_pos - b.start_pos).map(mapSpellcheckChange),
        finalText,
    });
};
const postMetric = (metric) => axios.post("/api/admin/spellcheck-metrics", metric);
const patchMetric = (requestId, metric) => axios.patch(`/api/admin/spellcheck-metrics/${requestId}`, metric);
const mapSpellcheckChange = (change, index) => ({
    order: index,
    startPos: change.start_pos,
    endPos: change.end_pos,
    previousFragment: change.previous_fragment,
    newFragment: change.new_fragment,
    accepted: change.accepted,
});
